import { useState } from 'react';
import { useTranslate, urlValue, unfolder } from '../../lib'
import { TextareaNesting } from '../common/Inputs/Input'
import axios from 'axios'
import PromptTemplateModal from '../../components/PromptTemplateModal';
import TemplateIcon from '../../images/overall.svg'

export default function WizardStep2({ formData, setFormData, refs }) {
  const { t } = useTranslate();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const verifyPrompt = () => {
    // Implementar validación de prompt
    console.log("Verify prompt");
  };

  const addPromptDefaultFromServer = () => {
    // Implementar carga de prompt por defecto
    console.log("Add prompt default");
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    axios({
      method: 'get',
      url: `${urlValue}/studio/prompt/library/default`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        setFormData({ ...formData, contact_driver_context: response?.data?.context, contact_driver_example: response.data?.example })
      })
      .catch(function (error) {
        // openAlert('#alert-ac', () => { setAlert({ title: t('alerts.failedTemplate'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
        console.error(error)
        // onClose()
        // setLoading(false)
      });
  };

  const handleSelectTemplate = (templateContent) => {
    const contentToAdd = typeof templateContent === 'string' ? templateContent : templateContent.content;
    console.log("contentToAdd:", contentToAdd);

    const currentContext = formData.contact_driver_context || '';
    const newContext = (currentContext ? currentContext + "\n" : "") + contentToAdd;

    setFormData(prev => ({
        ...prev,
        contact_driver_context: newContext
    }));

    //if (refs.contact_driver_context_ref && refs.contact_driver_context_ref.current) {
    //    refs.contact_driver_context_ref.current.value = newContext;
    //}

    setIsModalOpen(false);
};

  return (
    <div className="wizard-step">
      <h2 className="mb-4" style={{ color: '#0B5FA3', fontSize: 20 }}>
        {t('menu.genai.contactDriver')}
      </h2>

      <div className="d-flex flex-column pl-2" style={{ width: '100%', paddingRight: 15 }}>
        <div className='mt-4 d-flex flex-row flex-wrap align-items-center justify-content-between w-100'>
          <div className="flex-row align-items-center w-100"
            style={{ marginRight: 20, display: 'flex', justifyContent: 'space-between', minWidth: 302 }}>
            <button className='btn-add' type='button' onClick={verifyPrompt}>
              <img src='/icons/verify_prompt.png' style={{ width: 22 }} alt='' />
              <span className='ml-5'>{t('menu.genai.verifyPrompt')}</span>
            </button>
            <div className='d-flex flex-row align-items-center'>
              {/*<button className='buttonE buttonH' type='button' onClick={addPromptDefaultFromServer}>
                <img src='/icons/add-icon-nt.png' style={{ width: 22 }} alt='' />
                <span className='ml-5'>{t('menu.genai.addPromptTemplate')}</span>
              </button>*/}
              <button className='buttonE buttonH' 
                    type='button' onClick={() => setIsModalOpen(true)} 
                    style={{minWidth: 150, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <img src={TemplateIcon} style={{ width: 22 }} alt='' /> 
                  <span style={{marginLeft: 10}}>{t('common.templates')}</span>
              </button>
            </div>
            
          </div>
        </div>

        <div className="flex-row flex-wrap" style={{ display: 'flex' }}>
          <div className='d-flex flex-column mt-2' style={{ flexGrow: '2' }}>
            <div className='d-flex flex-row align-items-center justify-content-between'>
              <label htmlFor="contact_driver_context" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>
                {t('menu.genai.context')}:
              </label>
            </div>
            <div className='flex items-center'>
              <TextareaNesting
                row={11}
                id="contact_driver_context"
                defaultValue={formData.contact_driver_context}
                onChange={(e) => setFormData({ ...formData, contact_driver_context: e.target.value })}
                title=""
                containerClass="flex-1 mr-2 mt-0"
              />
            </div>
          </div>

          <div className='d-flex flex-column w-100' style={{ flexGrow: '1' }}>
            <div className='mt-4 d-flex flex-row align-items-center justify-content-between'>
              <label htmlFor="contact_driver_example" style={{ margin: 0, fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>
                {t('menu.genai.example')}:
              </label>
            </div>
            <div className='flex items-center'>
              <TextareaNesting
                row={4}
                id="contact_driver_example"
                defaultValue={formData.contact_driver_example}
                onChange={(e) => setFormData({ ...formData, contact_driver_example: e.target.value })}
                title=""
                containerClass="flex-1 mr-2 mt-0"
              />
            </div>
          </div>
        </div>
      </div>

      <PromptTemplateModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSelect={handleSelectTemplate}
          hideCreate={true}
      />

    </div>
  );
}
